import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { supabase } from '../supabaseClient';

export default function Navbar() {
  const [user, setUser] = useState(null);
  const [mobOpen, setMobOpen] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const location = useLocation();

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => setUser(session?.user || null));
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_e, session) => setUser(session?.user || null));

    const updateCount = () => {
      try {
        const cart = JSON.parse(localStorage.getItem('engimitra_cart') || '[]');
        setCartCount(cart.length);
      } catch (e) {
        setCartCount(0);
      }
    };
    
    updateCount();
    window.addEventListener('storage', updateCount);
    const interval = setInterval(updateCount, 1000);

    return () => {
      subscription?.unsubscribe();
      window.removeEventListener('storage', updateCount);
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (mobOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobOpen]);

  const isHome = location.pathname === '/';

  return (
    <>
      <nav className="em-nav">
        {isHome ? (
          <a href="#hero" className="em-logo">
            <span className="l1">ENGI</span>
            <span className="l2">&lt;mitra&gt;</span>
          </a>
        ) : (
          <Link to="/" className="em-logo">
            <span className="l1">ENGI</span>
            <span className="l2">&lt;mitra&gt;</span>
          </Link>
        )}

        <ul className="em-nav-links">
          <li><Link to="/courses">Courses</Link></li>
          <li><Link to="/notes">Notes</Link></li>
          <li><Link to="/mpqs">MPQs</Link></li>
          <li>
            <Link to="/cart" style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
              Cart
              {cartCount > 0 && (
                <span style={{
                  background: 'var(--accent, #00e5c8)',
                  color: '#002022',
                  fontSize: '0.7rem',
                  fontWeight: '800',
                  padding: '2px 6px',
                  borderRadius: '10px',
                  lineHeight: '1'
                }}>
                  {cartCount}
                </span>
              )}
            </Link>
          </li>
        </ul>

        <div className="em-nav-r">
          {user ? (
            <Link to="/account" className="btn-cta em-dashboard-link" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <span className="material-symbols-outlined" style={{ fontSize: '1.2rem' }}>account_circle</span>
              Dashboard
            </Link>
          ) : (
            <>
              <Link to="/login" className="btn-ghost">Login</Link>
              <Link to="/signup" className="btn-cta">Get Started</Link>
            </>
          )}
        </div>

        <button
          className={`hbg${mobOpen ? " open" : ""}`}
          onClick={() => setMobOpen(v => !v)}
          aria-label={mobOpen ? "Close menu" : "Open menu"}
          aria-expanded={mobOpen}
        >
          <span />
          <span />
          <span />
        </button>
      </nav>

      <div className={`mob-nav${mobOpen ? " open" : ""}`}>
        <Link to="/courses" onClick={() => setMobOpen(false)}>Courses</Link>
        <Link to="/notes" onClick={() => setMobOpen(false)}>Notes</Link>
        <Link to="/mpqs" onClick={() => setMobOpen(false)}>MPQs</Link>
        <Link to="/cart" onClick={() => setMobOpen(false)} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          Cart
          {cartCount > 0 && (
            <span style={{
              background: 'var(--accent, #00e5c8)',
              color: '#002022',
              fontSize: '0.75rem',
              fontWeight: '800',
              padding: '2px 8px',
              borderRadius: '10px'
            }}>
              {cartCount}
            </span>
          )}
        </Link>
        {user ? (
          <Link to="/account" onClick={() => setMobOpen(false)} style={{ color: "var(--accent)", fontWeight: 'bold' }}>Dashboard →</Link>
        ) : (
          <>
            <Link to="/login" onClick={() => setMobOpen(false)} style={{ color: "var(--accent)" }}>Login</Link>
            <Link to="/signup" onClick={() => setMobOpen(false)} style={{ color: "var(--accent)" }}>Get Started →</Link>
          </>
        )}
      </div>
    </>
  );
}
